async function waitForParcely() {
  let whileEnabled = true;
  setTimeout(() => {
    whileEnabled = false;
  }, 10000);
  let widget = document.querySelector(".parcely_app");
  let checkoutBlock = document.querySelector(".cart__ctas");
  let dynamicBtn = document.querySelector("#dynamic-checkout-cart");
  while (!widget && whileEnabled) {
    console.log(checkoutBlock);
    widget = document.querySelector(".parcely_app");
    checkoutBlock = document.querySelector(".cart__ctas");
    dynamicBtn = document.querySelector("#dynamic-checkout-cart");
    if (checkoutBlock) {
      checkoutBlock.style.visibility = "hidden";
    }
    if (dynamicBtn) {
      dynamicBtn.style.visibility = "hidden";
    }
    await new Promise((r) => setTimeout(r, 50));
  }
  checkoutBlock.style.visibility = "visible";
  dynamicBtn.style.visibility = "visible";
}

waitForParcely();
